// extracted by mini-css-extract-plugin
module.exports = {"module":"SendAsGiftQuestion_module__VmQe_","text":"SendAsGiftQuestion_text__3UXHd"};